import React, { Component } from 'react';
import * as _ from "lodash";

import Draft from './Draft';
import LoadingSpinner from '../Utilities/LoadingSpinner';

import "./Drafts.css"

class Drafts extends Component {

    constructor(props) {
        super(props);
        this.renderDrafts = this.renderDrafts.bind(this);
    }

    componentDidMount() {
        this.props.fetchAllDrafts();
        this.props.fetchAllTeams();
    }

    renderDrafts(isPastSeason){
        let draftOutput = [];
        let component = this;

        if (!_.isEmpty(this.props.drafts)) {
            let draftSeason = isPastSeason ? this.props.drafts.pastSeasons : this.props.drafts.currentSeasons;
            let draftList = _.map(draftSeason, (draft, index) => {
                return draft;
            });

            draftList.forEach(function (draft, draftIndex) {
                draftOutput.push(
                <Draft key={`draft-${draftIndex}`} 
                    draft={draft} 
                    teams={component.props.teams} 
                    authenticated={component.props.user.isAuthenticated}
                    isAdmin={component.props.user.isAdmin} />
                );
            });
        }
        return draftOutput;

    }

    render() {
        return (
            <div>
                {this.props.draftsLoading.isLoading
                ? (
                    <LoadingSpinner />
                ) 
                : (
                    <div>
                        <h1>Drafts</h1>
                        <div className="row">
                            {this.renderDrafts(false)}
                        </div>
                        <div className={(this.props.drafts && 
                        this.props.drafts.pastSeasons && 
                        Object.keys(this.props.drafts.pastSeasons).length > 0 ? "" : "d-none")}>
                            <h2 className={"mt-5 "}>Past Seasons</h2>
                            <div className="row">
                                {this.renderDrafts(true)}
                            </div>
                        </div>
                    </div>
                )}
                
            </div>
        );
    }
}

export default Drafts;



// WEBPACK FOOTER //
// ./src/components/Draft/Drafts.js